"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMeterReadAnalyticsData = void 0;
var getMeterReadAnalyticsData = function (supply, fuel) { return ({
    fuel: fuel,
    isSmart: supply.states.isSmart,
    isNonComms: supply.states.isNonComms,
    isInOMRWindow: supply.states.isOnboarding,
    isOnboarding: supply.states.isOnboarding,
    msnData: !!supply.msn,
    mpxnData: !!supply.sprn,
}); };
exports.getMeterReadAnalyticsData = getMeterReadAnalyticsData;
